var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timetable-date"},[_c('div',{staticClass:"date-box row"},[_c('div',{staticClass:"col-4 text-align-left padding-none"},[_c('div',{staticClass:"today-btn cursor-pointer"},[_vm._v("今天")])]),_c('div',{staticClass:"col-4 padding-none"})])])
}]

export { render, staticRenderFns }